'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _loginModal = require('@/page/business/login-modal');

var _loginModal2 = _interopRequireDefault(_loginModal);

var _modal = require('@/components/modal');

var _modal2 = _interopRequireDefault(_modal);

var _vuex = require('vuex');

var _broadcastDxGd = require('./page/index/components/broadcast-dx-gd.vue');

var _broadcastDxGd2 = _interopRequireDefault(_broadcastDxGd);

var _header = require('@/page/header');

var _header2 = _interopRequireDefault(_header);

var _function = require('@/page/header/function');

var _function2 = _interopRequireDefault(_function);

var _index_dx = require('@/page/footer/index_dx.vue');

var _index_dx2 = _interopRequireDefault(_index_dx);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import BayWindow from '@/components/bay-window'
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'App',
  created: function created() {
    this.setLang('zh_CN');
    // this.showDom()
    this.setBg();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
    skin: 'SKIN'
  }), {
    setMinheight: function setMinheight() {
      var height = (document.documentElement.offsetHeight || document.body.offsetHeight) - 204;
      this.mainstyle['min-height'] = height + 'px';
    },
    setLang: function setLang(lang) {
      this.$i18n.locale = lang;
      document.body.setAttribute('lang', lang);
      //this.$api.cookies.set('lang', lang, 1)
      localStorage.lang = lang;
    },
    showDom: function showDom() {
      //todo  修改为全局配置
      // 其他个别单独处理
      var otherHideHead = ['concatDetail'],
          otherHideFoot = ['learnMap'],
          lbShowList = ['index'];
      this.showLB = true;
      this.showOtherHead = true;
      this.showOtherFoot = true;
      if (otherHideHead.includes(this.$route.name)) {
        this.showOtherHead = false;
      }
      if (!lbShowList.includes(this.$route.name)) {
        this.showLB = false;
      }
      if (otherHideFoot.includes(this.$route.name)) {
        this.showOtherFoot = false;
      }
      // for (let item of store.state.hideRouterName) {
      var _arr = ['/login', '/toonLogin', '/retrieve', '/bandingPhone', '/registerPhone', '/bandingOk', '/agreement', '/toonUnified', '/bjouUnified', '/dxExamNotice', '/dxpaper', '/dxExamRecord', '/dxExamResult', '/dxparsepaper'];
      if (!_store2.default.state.hideRouterName.includes(this.$route.name) && !_arr.includes(this.$route.path)) {
        this.showHF = true;
      } else {
        this.showHF = false;
      }
    },
    setBg: function setBg() {
      var bodtDom = document.getElementsByTagName('body')[0];
      // for (let item in store.state.bgRouter) {
      //   for (let i of store.state.bgRouter[item]) {
      //     if (this.$route.path.indexOf(i) > -1) {
      //       bodtDom.style.background = item
      //       return
      //     }
      //   }
      // }
      bodtDom.style.background = '#F3F4F4';
    },
    compatibleAnimation: function compatibleAnimation() {
      window.requestAnimationFrame = window.requestAnimationFrame || function (fn) {
        return setTimeout(fn, 1000 / 60);
      };
      window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
    },
    initFooter: function initFooter() {
      this.$refs.Footer.initScroll();
    }
  }),
  data: function data() {
    return {
      mainstyle: {
        'min-height': '100%'
      },
      bgstyle: {
        'background': '#fff'
      },
      showHF: false,
      lang: 'zh_CN',
      $local: '',
      $i18n: '',
      $api: '',
      globalTitls: '',
      showLB: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.setMinheight();
    };
    this.compatibleAnimation();
  },

  watch: {
    '$route': function $route(to) {
      this.setMinheight();
      this.showDom();
      this.setBg();
      this.compatibleAnimation();
      // 考试界面添加蓝色样式，其余为红色样式
      var blurList = ['dxExamNotice', 'dxpaper', 'dxpaperresult', 'dxExamRecord', 'dxExamResult', 'dxparsepaper'];
      if (to.path && blurList.includes(to.name)) {
        document.getElementsByTagName('body')[0].className = 'demo-style-class-body';
      } else {
        document.body.removeAttribute('class', 'demo-style-class-body');
      }
    },

    '$store.state.flushContent': function $storeStateFlushContent(val) {
      if (val && val == 'login') {
        this.$refs.loginModal.open();
      }
    }
  },
  components: {
    Heade: _header2.default,
    Footer: _index_dx2.default,
    Modal: _modal2.default,
    LoginModal: _loginModal2.default,
    HeadeIndex: _function2.default,
    broadcastdx: _broadcastDxGd2.default
  }
};